// extracted by mini-css-extract-plugin
export default {"card":"styles_card__NubT7","cardBody":"styles_cardBody__aD3Nd","title":"styles_title__Y-JDG","footer":"styles_footer__Pk00R"};